module.exports = __webpack_public_path__ + "img/revisao-meio-do-ano.b6b7b6e1.jpg";